var App = window.App = {

	Tools: {},

	compiledTemplates: {},
	baseURL: null,

	route: function() {
		return '/' + Array.prototype.join.call(arguments, "/");
	},

	render: function(tplID, context) {

		var tpl = App.compiledTemplates[tplID];

		if(tpl) {
			console.log("[app.render] Template #"+tplID+" is cached, using cache: ", tpl);
			return tpl(context);
		}

		var source = $('#' + tplID).html();

		if(!source) {
			console.error("[app.render] Cannot render template #"+tplID+": template does not exist");
			return "";
		}

		console.log("[app.render] Compiling template #"+tplID+", ", source.length, " bytes");

		App.compiledTemplates[tplID] = Handlebars.compile(source);

		return App.compiledTemplates[tplID](context);

	},

	setupHelpers: function(){},

	traceCredits: function() {
		console.group();
		console.log('\t');
		console.log('\tStockholm CRM');
		console.log('\tCopyright (c) LQDI Digital');
		console.log('\tAll Rights Reserved - 2015 - www.lqdi.net');
		console.log('\t');
		console.groupEnd();
	},

	setup: function(baseURL) {

		App.baseURL = baseURL;

		App.traceCredits();
		App.setupHelpers();

	}

};
